module.exports = __webpack_public_path__ + "static/media/img102.2a5849ac.png";